import { useMemo } from "react";
import { FiPlus } from "react-icons/fi";
import ReactSelect from "react-select";
import "../styles/AssetLinkField.css";

const assetLinkFieldStyles = {
  control: (baseStyles, state) => ({
    ...baseStyles,
    background: "transparent",
    border: "none",
    boxShadow: "none",
    minHeight: 30,
    cursor: state.isDisabled ? "not-allowed" : "pointer",
    "&:hover": {
      border: "none",
    },
  }),
  container: (baseStyles) => ({
    ...baseStyles,
    width: "100%",
  }),
  valueContainer: (baseStyles) => ({
    ...baseStyles,
    padding: 0,
  }),
  placeholder: (baseStyles) => ({
    ...baseStyles,
    color: "#c4c0d0",
    fontSize: "16px",
    fontWeight: 400,
    margin: 0,
  }),
  singleValue: (baseStyles) => ({
    ...baseStyles,
    color: "#3d3f5c",
    fontSize: "16px",
    fontWeight: 500,
    margin: 0,
  }),
  input: (baseStyles) => ({
    ...baseStyles,
    color: "#3d3f5c",
    fontSize: "16px",
    margin: 0,
    padding: 0,
  }),
  indicatorSeparator: () => ({
    display: "none",
  }),
  dropdownIndicator: (baseStyles) => ({
    ...baseStyles,
    color: "#111",
    padding: 0,
  }),
  menu: (baseStyles) => ({
    ...baseStyles,
    zIndex: 9999,
  }),
  menuPortal: (baseStyles) => ({
    ...baseStyles,
    zIndex: 9999,
  }),
  option: (baseStyles) => ({
    ...baseStyles,
    fontSize: "14px",
    cursor: "pointer",
  }),
};

const mergeSelectStyles = (customStyles = {}) => {
  const mergedStyles = {
    ...assetLinkFieldStyles,
    ...customStyles,
  };

  [
    "control",
    "container",
    "valueContainer",
    "placeholder",
    "singleValue",
    "input",
    "indicatorSeparator",
    "dropdownIndicator",
    "menu",
    "menuPortal",
    "option",
  ].forEach((key) => {
    if (assetLinkFieldStyles[key] && customStyles[key]) {
      mergedStyles[key] = (base, state) => ({
        ...assetLinkFieldStyles[key](base, state),
        ...customStyles[key](base, state),
      });
    }
  });

  return mergedStyles;
};

const AssetLinkField = ({
  className = "",
  icon = <FiPlus />,
  customStyles = {},
  label = "",
  placeholder = "",
  options = [],
  loading = false,
  name,
  value,
  onChange,
  onBlur,
  error,
  touched,
  isSearch = false,
  isDisabled = false,
  menuPortalTarget = null,
}) => {
  const resolvedMenuPortalTarget = useMemo(() => {
    if (menuPortalTarget !== null) return menuPortalTarget;
    return typeof document !== "undefined" ? document.body : null;
  }, [menuPortalTarget]);

  const mergedStyles = useMemo(
    () => mergeSelectStyles(customStyles),
    [customStyles]
  );

  return (
    <div className={`asset_link_field ${className}`.trim()}>
      <div className={`asset_link_field_container ${isDisabled ? "disabled" : ""}`}>
        <span className="asset_link_field_icon">{icon}</span>

        <div className="asset_link_field_content">
          <div className="asset_link_field_label">{label}</div>

          <ReactSelect
            isLoading={loading}
            options={options}
            placeholder={placeholder}
            styles={mergedStyles}
            name={name}
            value={value}
            onChange={onChange}
            onBlur={onBlur}
            isDisabled={isDisabled}
            isSearchable={isSearch}
            menuPortalTarget={resolvedMenuPortalTarget}
            menuPosition={resolvedMenuPortalTarget ? "fixed" : "absolute"}
          />
        </div>
      </div>

      {touched && error ? (
        <div
          className="error-message"
          style={{ color: "#ff0000de", fontSize: "12px", marginTop: "3px", marginLeft: "5px" }}
        >
          {error}
        </div>
      ) : null}
    </div>
  );
};

export default AssetLinkField;
